class s{}export{s as GLProbe};
//# sourceMappingURL=GLProbe.min.mjs.map
